module.exports = __webpack_public_path__ + "img/btm.985d8c97.svg";